import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { compose } from 'recompose';
import styled from 'styled-components';
import { withLocalize } from 'react-localize-redux';
import { Grid } from 'semantic-ui-react';
import FeaturedTile from './tile/featuredTile';

const FeaturedEventCards = props => {
  const { user, featuredEvents } = props;

  if (isEmpty(featuredEvents)) {
    return (
      <div>No featured events</div>
    );
  }

  if (user.isLoggedIn) {
    const { participantsEvents, manageEvents } = props;

    return (
      <StyledGrid>
        {featuredEvents.map(event => (
          <Grid.Column
            key={`feature-${event.slug}`}
            width={8} computer={8} mobile={16}
            className='col'
          >
            <FeaturedTile
              event={event} user={user} participantsEvents={participantsEvents}
              manageEvents={manageEvents}
            />
          </Grid.Column>
        ))}
      </StyledGrid>
    );
  }

  return (
    <StyledGrid>
      {featuredEvents.map(event => (
        <Grid.Column
          key={`feature-${event.slug}`}
          width={8} computer={8} mobile={16}
          className='col'
        >
          <FeaturedTile event={event} user={user} />
        </Grid.Column>
      ))}
    </StyledGrid>
  );
};

const StyledGrid = styled(Grid)`
  &&&.ui.grid {
    @media only screen and (max-width: 375px) {
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 0;
    margin-left: 0;
    }
  }
`;

export default compose(
  withLocalize,
  connect(({ user }) => ({ user }))
)(FeaturedEventCards);




// WEBPACK FOOTER //
// ./src/components/events/components/featuredEventCards.js